/**
 * Upload / request / retry budgets — shared, dependency-free constants and pure
 * helpers so both the app and the test suite can import them safely.
 *
 * Values are documented in docs/chat-agent.md ("Client budgets").
 */

/** No upload progress for this long ⇒ the XHR is aborted and rejected. */
export const UPLOAD_INACTIVITY_MS = 30_000;

/** prepare / finalize / status fetch deadline. */
export const REQUEST_DEADLINE_MS = 20_000;

/** Receipt status polling backoff (ms): 1s,2s,4s,8s… capped, ~60s total. */
export const STATUS_BACKOFF_MS = [1_000, 2_000, 4_000, 8_000, 8_000, 8_000, 8_000, 8_000];

/**
 * Total upload deadline = max(120s, ~2s per MB). Larger files get more time,
 * but never less than two minutes.
 */
export function uploadTotalDeadlineMs(bytes: number): number {
  return Math.max(120_000, Math.ceil(Math.max(bytes, 0) / (1024 * 1024)) * 2_000);
}

/**
 * Durable intake-job retry backoff: 1,2,4,8,16,32,60… minutes (capped at 60).
 * Mirrors the worker's backoffMs() in process-intake-jobs.
 */
export function jobBackoffMs(attempts: number): number {
  return Math.min(60, Math.pow(2, Math.max(attempts - 1, 0))) * 60 * 1000;
}

/** Dead-letter once the job has used up its attempts. */
export function shouldDeadLetter(attempts: number, maxAttempts: number): boolean {
  return attempts >= maxAttempts;
}